import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { Inject } from "@angular/core";
import { CONFIG } from "app/shared/constants/config";
import { VOICE_API_PATHS } from "app/shared/constants/voice-api-paths";
import { environment } from "environments/environment";

export class UcbInterceptor implements HttpInterceptor {
  // this interceptor only responsible for all UC Backend api and not voice Api

  private customRequest: HttpRequest<any> | undefined;

  private ignoreList: string[] = ["user/login", "svg"];

  constructor(
    @Inject(VOICE_API_PATHS)
    private voiceApiPaths: string[],
  ) {}
  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (this.isInvalidApi(request)) {
      return next.handle(request);
    }

    this.customRequest = request.clone();
    if (
      !request.url.includes("voice-control-api") &&
      !request.url.startsWith(environment.keycloakConfig.url)
    ) {
      this.attachContentTypeHeader();
      this.attachAcceptHeader();
      this.attachNfonHeadersToRequest();
    }

    return next.handle(this.customRequest!).pipe(
      catchError((httpErrorResponse: HttpErrorResponse) => {
        return throwError(httpErrorResponse);
      }),
    );
  }

  private isInvalidApi(request: HttpRequest<any>): boolean {
    const selectedVoiceIndex: number = this.voiceApiPaths.findIndex(
      (ignoreItem: string) => request.url.includes(ignoreItem),
    );

    const selectedIgnoreListIndex: number = this.ignoreList.findIndex(
      (ignoreItem: string) => request.url.includes(ignoreItem),
    );
    return selectedVoiceIndex > -1 || selectedIgnoreListIndex > -1;
  }

  private attachContentTypeHeader(): void {
    if (this.customRequest?.body) {
      this.setRequestHeader("Content-Type", "application/json");
    }
  }

  private attachAcceptHeader(): void {
    if (!this.customRequest?.headers.has("Accept")) {
      this.setRequestHeader("Accept", "application/json");
    }
  }

  private attachNfonHeadersToRequest(): void {
    this.setRequestHeader("X-NFON-TYPE", "webapp");
    this.setRequestHeader("X-NFON-VERSION", CONFIG.VERSION);
  }

  private setRequestHeader(
    headerName: string,
    headerValue: string | string[],
  ): void {
    if (this.customRequest) {
      this.customRequest = this.customRequest.clone({
        headers: this.customRequest.headers.set(headerName, headerValue),
      });
    }
  }
}
